import React, { useCallback, useRef, useState } from "react";

import { ThumbnailProps } from "./types";
import ThumbnailWrapper from "./ThumbnailWrapper";
import ColorDisplay from "@components/kits/ColorDisplay";
import useResizeObserver from "@components/hooks/useResizeObserver";

function ColorThumbnail({ asset }: ThumbnailProps) {
  const [smallMode, setSmallMode] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleResize = useCallback((node: Element) => {
    setSmallMode(node.clientWidth < 100);
  }, []);

  useResizeObserver(wrapperRef, handleResize);
  return (
    <ThumbnailWrapper ref={wrapperRef}>
      <ColorDisplay asset={asset} smallMode={smallMode} />
    </ThumbnailWrapper>
  );
}

export default React.memo(ColorThumbnail);
